module.exports = __webpack_public_path__ + "img/section3_banner1.14218e39.jpg";